// This file is essential to match Languages from Lookups with Language Codes.
// It means that the lookup record should be named exactly as in this list.
const languageCodes = [
  { code: "en", name: "English" },
  { code: "es", name: "Spanish" },
  { code: "pt", name: "Portuguese" },
  { code: "ko", name: "Korean" },
  { code: "fr", name: "French" },
  { code: "ht", name: "Haitian Creole" },
  { code: "hmn", name: "Hmong" },
  { code: "my", name: "Burmese" },
  { code: "uk", name: "Ukrainian" },
  { code: "ru", name: "Russian" },
  { code: "zh-CN", name: "Chinese" },
  { code: "fil", name: "Filipino" },
];

export function languageName(code) {
  return languageCodes.find((language) => language.code === code)?.name ?? code;
}

export default languageCodes;
